import styles from "./Header.module.scss"

import React, { MouseEvent } from "react"
import { useParams } from "react-router-dom"

import { Header as CommonHeader, FullMode } from "@shared/components"
import { WOWNET_CONTENT } from "@shared/constants"
import { useLayerPopupContext } from "@shared/contexts"

import { useWowMoneyContext } from "live/contexts"
import { Player } from "live/modules"
import { VodPlayer } from "vod/contexts"

import { NumberOfViewers } from "./numberOfViewers"
import Setting from "./Setting"
import Volume from "./Volume"
import { WowMoneyTimer } from "./wowMoneyTimer"

interface Props {
  player: Player | VodPlayer
}

export default function Header({ player }: Props) {
  const { streamerName } = useParams<{ streamerName?: string }>()
  const { open } = useLayerPopupContext()
  const { isFreeSchedule } = useWowMoneyContext()

  /**
   * 무료 편성에서는 적립 현황을 띄운다. 방송이 끝나도 자리를 유지하고
   * 남은 시간만 "-" 로 표기한다.
   * 유료 편성에서는 기존 상단바(시청자 수 · 알림)를 그대로 둔다.
   */
  const left = isFreeSchedule
    ? [<WowMoneyTimer key="wowmoneytimer" />]
    : [
        <NumberOfViewers key="numberofviewers" />,
        <div key="iframe" className="iframeB">
          <iframe
            title="알림"
            className={styles.headerSize}
            src={`${WOWNET_CONTENT.header}?analid=${streamerName}`}
          />
        </div>,
      ]

  return (
    <CommonHeader
      left={left}
      right={[
        <Volume key="volume" player={player as Player} />,
        <FullMode key="fullmode" player={player} />,
        <Setting key="setting" />,
        <li key="off" className="off">
          <a
            href="#!"
            onClick={(e: MouseEvent) => {
              e.preventDefault()
              open("LIVE_END_VOD")
            }}
            title="방송종료"
          >
            <i>OFF</i>방송종료
          </a>
        </li>,
      ]}
    />
  )
}
